export default __webpack_public_path__ + "static/media/qlty.f0dbb571.svg";